module.exports = __webpack_public_path__ + "img/ee1.977bfb74.svg";